import { useEffect, useRef, useState } from "react";
import "./fileUpload.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import bg_image from "../../images/bg_image.jpg";
import logo from "../../images/logo.png";
import logout from "../../images/logout.png";
import loading from "../../images/loading.gif";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import ToggleSwitch from "../../components/ToggleSwitch/ToggleSwitch";
import { useDispatch, useSelector } from "react-redux";
import { authentication } from "../../redux/features/authenticationSlice/authenticationSlice";


function FileUpload() {
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [fileType, setFileType] = useState("Employee");

  const inputRef = useRef(null);
  const navigate = useNavigate();

  // let sessionIdCheck = Cookies.get("uid");
  // console.log(sessionIdCheck, "check");

  const dispatch = useDispatch();

  const authToken = useSelector((state) => state.authentication.authToken);
  // console.log(authToken);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setError("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (file !== null) {
      setIsLoading(true);

      const formData = new FormData();
      formData.append(fileType === "Employee" ? "upload" : "festival", file);

      try {
        const config = {
          method: "post",
          url:
            fileType === "Employee"
              ? `${process.env.REACT_APP_BASE_URL}/users`
              : `${process.env.REACT_APP_BASE_URL}/festivals`,
          withCredentials: true,
          headers: {
            "Content-Type":
              "multipart/form-data; boundary=<calculated when request is sent>",
          },
          data: formData,
        };
        const response = await axios(config);
        // console.log("Response:", response);
        toast.success("File has been uploaded!");
        inputRef.current.value = "";
        setFile(null);
      } catch (error) {
        setIsLoading(false);
        // console.error("Error:", error);
        if (error?.response?.status == 401) {
          toast.error("Session timed out");
          setTimeout(() => {
            navigate("/login");
          }, 5000);
        } else {
          toast.error("Something went wrong, please try again later");
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      setError("No file selected");
    }
  };

  const logoutHandler = () => {
    Cookies.remove("uid");
    dispatch(authentication(false));
    navigate("/login");
  };

  const onFileTypeChange = (check) => {
    setFileType(check);
  };

  useEffect(() => {
    // const getCookie = () => {
    //   let sessionId = Cookies.get("uid", { domain: "hrms-server.hellomentor.online" });
    //   console.log(sessionId, "session id" )

    //   if (!sessionId) {
    //     console.log("taken back to login")
    //     navigate("/login");
    //   }
    // };
    // getCookie();

    if (!authToken) {
      navigate("/login");
    }
  }, []);

  return (
    <div className="container">
      <img src={bg_image} alt="bg_image" className="bg_image" />
      <div className="file_header">
        <img src={logo} alt="logo" className="logo" width={200} height={40} />
        <div className="logout_section">
          <img
            onClick={logoutHandler}
            src={logout}
            alt="logo"
            className="logo"
            width={25}
            height={25}
          />
          <p onClick={logoutHandler} className="logout_font">
            Logout
          </p>
        </div>
      </div>
      <div className="upload_type_btn">
        <ToggleSwitch fileType={fileType} onFileTypeChange={onFileTypeChange} />
      </div>
      <div className="form_container">
        <h2>Upload the {fileType} file</h2>
        <form onSubmit={handleSubmit} className="form_style">
          <input
            type="file"
            onChange={handleFileChange}
            className="file_style"
            ref={inputRef}
          />
          <p className="error_tag">{error}</p>
          {isLoading ? (
            <img src={loading} alt="loading" width={40} height={40} />
          ) : (
            <button type="submit" className="button_style">
              Upload
            </button>
          )}
        </form>
      </div>
      <ToastContainer position="top-center" />
    </div>
  );
}

export default FileUpload;
